import React from 'react';
import { useActiveUserContext, useAssignedAppTypeContext, useDataRequestPermissionsContext } from '@vivli/core/infrastructure/context';
import { PermissionsEnum } from '@vivli/shared/infrastructure/enum';
import { IOrganization } from '@vivli/features/organizations/infrastructure/interface';
import { OrgDetailsBasicInformation } from './org-details-basic-information.component';
import { OrgDetailsSectionComponent } from './org-details-section.component';
import { OrganizationPolicies } from './organization-policies.component';
import { OrgResourcesLinkComponent } from './modals/org-resources-link.component';

interface OrgDetailsTabComponentProps {
    organization: IOrganization;
}

export const OrgDetailsTabComponent = ({ organization }: OrgDetailsTabComponentProps) => {
    const { user, hasPermission, orgHasPermission } = useActiveUserContext();
    const { isAmr } = useAssignedAppTypeContext();
    const dataRequestPermissions = useDataRequestPermissionsContext();

    //TODO PERMFE - redo with permissions+
    const showOrgPoliciesContent =
        !isAmr &&
        (hasPermission(PermissionsEnum.CreateOrg) ||
            dataRequestPermissions.isOrgMember(organization?.id, (om) =>
                orgHasPermission(organization?.id, PermissionsEnum.ProviderActAdv)
            ));

    return (
        <div>
            <OrgResourcesLinkComponent />
            <OrgDetailsBasicInformation />
            <OrgDetailsSectionComponent />
            <OrganizationPolicies showOrgPoliciesContent={showOrgPoliciesContent} organization={organization} />
        </div>
    );
};
